import React from 'react';
import {
    MinusOutlined,
    CaretDownOutlined,
    CaretUpOutlined,
    IconSizes,
} from '@landr/maestro';
import { ChartRankChange } from '../Charts.types';
import { IconWrapper } from '../Charts.styled';

export type ChartRankChangeIconProps = {
    rankChange: ChartRankChange;
    size: IconSizes;
};

export const ChartRankChangeIcon: React.FC<ChartRankChangeIconProps> = ({
    rankChange,
    size,
}) => {
    let Component;
    let color;

    switch (rankChange) {
        case ChartRankChange.Up:
            Component = CaretUpOutlined;
            color = 'primary.500';
            break;
        case ChartRankChange.Down:
            Component = CaretDownOutlined;
            color = 'danger.500';
            break;
        default:
            Component = MinusOutlined;
            color = 'neutral.400';
            break;
    }

    return (
        <IconWrapper>
            <Component size={size} color={color} />
        </IconWrapper>
    );
};
